import React, { useState, useContext, useMemo, useRef } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Input } from "design-react-kit";
import Pagination from "./Pagination";
import Select from "./Select";
import ModalComponent from "./ModalComponent";
import Repo from "../Utility/Repo";
import { TokenContext } from "./TokenContext";
import { useEffect } from "react";
import Loader from "./Loader";
import Badge from "./Badge";
import IO from "../Assets/Img/IO_bianco.svg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ListUsers = (props) => {
  const [personalizzaPagoPA, setPersonalizzaPagoPA] = useState(false);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");
  const [alertShow, setAlertShow] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [currentItems, setCurrentItems] = useState([]);
  let query = useQuery();
  const apiToken = useContext(TokenContext);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [changeSort, setChangeSort] = useState(false);
  const [changeSortRanking, setChangeSortRanking] = useState(true);
  const [isOpenUnsubscribe, toggleModalUnsubscribe] = useState(false);
  const [id, setId] = useState();
  const [userId, setUserId] = useState();
  const [editScore, toggleModalEditScore] = useState(false);
  const [fiscalcode, setSetFiscalcode] = useState();
  const [haveUsage, setHaveUsage] = useState();
  const [tempoCost, setSetTempoCost] = useState();
  const [pagamentoPersonalizzato, setPagamentoPersonalizzato] = useState({
    importoPagoPA: "",
    descrizione: "",
  });
  const [announcementId, setAnnouncementId] = useState("");
  const [isOpenRefuseUser, toggleRefuseUserModal] = useState(false);
  const [isOpenSuspendUser, toggleSuspendUserModal] = useState(false);
  const [isError, toggleModalErros] = useState(false);

  const [isOpenReactiveUser, toggleReactiveUserModal] = useState(false);
  const [isOpenReactiveRefusedUser, toggleReactiveRefusedUserModal] =
    useState(false);
  const [validation, setValidation] = useState(false);
  const [isOpenConfirmUser, toggleModalConfirmUser] = useState(false);
  const [isOpenConfirmHours, toggleModalConfirmHours] = useState(false);
  const [isOpenCSVUpload, toggleModalCSVUpload] = useState(false);
  const [editHours, toggleModalEditHours] = useState(false);
  const [isOpenGenerateCSV, toggleModalGenerateCSV] = useState(false);
  const [weeklyHour, setWeeklyHour] = useState();
  const [weeklyHourValidation, setWeeklyHourValidation] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [description, setDescription] = useState(null);
  const [loading, setLoading] = useState(true);
  const wasRunningRef = useRef(null);
  const lastSyncRef = useRef(null);

  const [syncStatus, setSyncStatus] = useState({
    isRunning: false,
    totalUsersToSync: 0,
    processedUsers: 0,
    synchronizedUsers: 0,
    progressPercentage: 0,
    lastError: "",
    finishedAt: null,
  });
  const [syncReloadArmed, setSyncReloadArmed] = useState(false);

  const [editScoreData, setEditScoreData] = useState({
    id: null,
    rankingScore: null,
    name: null,
  });

  const [editHoursData, setEditHoursData] = useState({
    id: null,
    weeklyHour: null,
    name: null,
  });

  const normalizeSyncStatus = (data = {}) => ({
    isRunning: data.IsRunning ?? data.isRunning ?? false,
    totalUsersToSync: data.TotalUsersToSync ?? data.totalUsersToSync ?? 0,
    processedUsers: data.ProcessedUsers ?? data.processedUsers ?? 0,
    synchronizedUsers: data.SynchronizedUsers ?? data.synchronizedUsers ?? 0,
    progressPercentage: data.ProgressPercentage ?? data.progressPercentage ?? 0,
    lastError: data.LastError ?? data.lastError ?? "",
    finishedAt: data.FinishedAt ?? data.finishedAt ?? null,
  });

  const formatLastSyncDate = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
      const match = value.match(
        /^(\d{2})\/(\d{2})\/(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/,
      );
      if (match) {
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10);
        const year = parseInt(match[3], 10);
        const hour = parseInt(match[4] || "0", 10);
        const minute = parseInt(match[5] || "0", 10);
        const second = parseInt(match[6] || "0", 10);
        const localDate = new Date(year, month - 1, day, hour, minute, second);

        if (!Number.isNaN(localDate.getTime())) {
          return localDate.toLocaleString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });
        }
      }
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const getPnrrSynchronizationStatus = () => {
    if (!apiToken) return;

    Repo.getPnrrSynchronizationStatus(apiToken, props?.session?.id)
      .then((response) => {
        const normalized = normalizeSyncStatus(response.data);
        setSyncStatus(normalized);
        if (normalized.finishedAt) {
          lastSyncRef.current = normalized.finishedAt;
        }
      })
      .catch(() => {
        // Manteniamo lo stato precedente se la lettura fallisce.
      });
  };

  const startPnrrSynchronization = () => {
    if (!apiToken || syncStatus.isRunning) return;

    Repo.startPnrrSynchronization(apiToken, props?.session?.id)
      .then(() => {
        setSyncReloadArmed(true);
        getPnrrSynchronizationStatus();
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "Sincronizzazione già in esecuzione o non disponibile.",
        );
        viewToggleModalErros();
      });
  };

  function formatNumber(value) {
    let cleanedValue = value.replace(/[^0-9.]/g, "");
    let [integerPart, decimalPart] = cleanedValue.split(".");

    if (decimalPart) {
      decimalPart = decimalPart.replace(/\./g, "");
      decimalPart = decimalPart.slice(0, 2);
    }

    let formattedValue = integerPart;
    if (cleanedValue.includes(".")) {
      formattedValue += "." + decimalPart;
    }
    return formattedValue;
  }

  const getFilteredItems = () => {
    const list =
      props.changeArray === false
        ? props.sessionSubscriptionTemp
        : props.sessionSubscriptionTemp2;
    return (
      list?.filter((x) => {
        if (
          props.filterSubscribed.fiscalCode &&
          !x.user?.fiscalCode
            ?.toLowerCase()
            .includes(props.filterSubscribed.fiscalCode.toLowerCase())
        )
          return false;
        if (
          props.filterSubscribed.nProtocollo &&
          !x.nProtocollo
            ?.toLowerCase()
            .includes(props.filterSubscribed.nProtocollo.toLowerCase())
        )
          return false;
        if (
          props.filterSubscribed.descrizione &&
          !x.descrizioneIstanze
            ?.replace(/<[^>]+>/g, "")
            ?.toLowerCase()
            .includes(props.filterSubscribed.descrizione.toLowerCase())
        )
          return false;
        if (props.filterSubscribed.city) {
          const hasCity = !!x.user?.city?.trim();
          if (props.filterSubscribed.city === "Non specificato" && hasCity)
            return false;
          if (
            props.filterSubscribed.city !== "Non specificato" &&
            (!hasCity ||
              x.user?.city?.toLowerCase() !==
                props.filterSubscribed.city.toLowerCase())
          )
            return false;
        }
        if (
          props.filterSubscribed.confirmed &&
          x.state !== props.filterSubscribed.confirmed
        )
          return false;
        if (paymentStatusFilter) {
          const usage = x.subscriptionUsages?.find(
            (u) => u.mese == props.filterMonth,
          );
          if (!usage) return false;
          if (paymentStatusFilter === "daCreare") {
            const hasBollettinoPagatoODaPagare = x.payments?.some(
              (y) =>
                (y.stato === 0 || y.stato === 1) &&
                y.subscriptionUsageId === usage.id,
            );
            return !hasBollettinoPagatoODaPagare && usage.cost > 0;
          }
          const hasPayment = x.payments?.some(
            (y) =>
              String(y.stato) === paymentStatusFilter &&
              y.subscriptionUsageId === usage.id,
          );
          return hasPayment;
        }
        return true;
      }) || []
    );
  };

  const filteredItems = useMemo(
    () => getFilteredItems(),
    [
      props.sessionSubscriptionTemp,
      props.sessionSubscriptionTemp2,
      props.changeArray,
      props.filterSubscribed,
      paymentStatusFilter,
      props.filterMonth,
    ],
  );

  const totalCount = filteredItems?.length || 0;

  const availableCities = useMemo(() => {
    const all = [
      ...(props.sessionSubscriptionTemp || []),
      ...(props.sessionSubscriptionTemp2 || []),
    ];
    const seen = new Set();
    const cities = all
      .map((x) => x?.user?.city)
      .filter((c) => c && c.trim().length > 0)
      .map((c) =>
        c
          .trim()
          .toLowerCase()
          .replace(/^\w/, (ch) => ch.toUpperCase()),
      )
      .filter((c) => {
        const key = c.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" }));

    const hasUnspecified = all.some((x) => !x?.user?.city?.trim());
    return hasUnspecified ? [...cities, "Non specificato"] : cities;
  }, [props.sessionSubscriptionTemp, props.sessionSubscriptionTemp2]);

  const [width, setWidth] = useState(window.innerWidth);

  const renderStatus = (state) => {
    switch (state) {
      case "VALIDATED":
        return (
          <span
            className="d-flex align-items-center text-success mr-3"
            title="Validato"
          >
            <svg className="icon icon-success mr-1">
              <use xlinkHref={`${iconSprite}#it-check-circle`} />
            </svg>
            Validato
          </span>
        );
      case "PAGAMENTO":
        return (
          <span
            className="d-flex align-items-center text-primary mr-3"
            title="Pagamento"
          >
            <svg className="icon icon-primary mr-1">
              <use xlinkHref={`${iconSprite}#it-card`} />
            </svg>
            Pagamento
          </span>
        );
      case "LOADED":
        return (
          <span
            className="d-flex align-items-center text-info mr-3"
            title="Caricato"
          >
            <svg className="icon icon-info mr-1">
              <use xlinkHref={`${iconSprite}#it-upload`} />
            </svg>
            Caricato
          </span>
        );
      case "SUSPENDED":
        return (
          <span
            className="d-flex align-items-center text-warning mr-3"
            title="Sospeso"
          >
            <svg className="icon icon-warning mr-1">
              <use xlinkHref={`${iconSprite}#it-ban`} />
            </svg>
            Sospeso
          </span>
        );
      case "REFUSED":
        return (
          <span
            className="d-flex align-items-center text-danger mr-3"
            title="Rifiutato"
          >
            <svg className="icon icon-danger mr-1">
              <use xlinkHref={`${iconSprite}#it-close-circle`} />
            </svg>
            Rifiutato
          </span>
        );
      case "ADDED":
        return (
          <span
            className="d-flex align-items-center text-secondary mr-3"
            title="Aggiunto"
          >
            <svg className="icon icon-secondary mr-1">
              <use xlinkHref={`${iconSprite}#it-plus-circle`} />
            </svg>
            Aggiunto
          </span>
        );
      default:
        return null;
    }
  };

  const suspendUser = (state, sub) => {
    var obj = {};

    obj = {
      id: sub.id,
      state: state,
      weeklyHour: sub.weeklyHour,
    };

    Repo.postConfirmUser(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.status == 200) {
          props.apiGet();
        }
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      })
      .finally(() => {
        toggleModalConfirmUser(false);
        toggleRefuseUserModal(false);
        toggleReactiveUserModal(false);
        toggleSuspendUserModal(false);
        toggleReactiveRefusedUserModal(false);
      });
  };

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    if (!apiToken) return;

    getPnrrSynchronizationStatus();
    const intervalId = setInterval(getPnrrSynchronizationStatus, 3000);

    return () => clearInterval(intervalId);
  }, [apiToken, props?.session?.id]);

  useEffect(() => {
    if (wasRunningRef.current === true && syncStatus.isRunning === false) {
      window.location.reload();
    }
    wasRunningRef.current = syncStatus.isRunning;
  }, [syncStatus.isRunning]);

  useEffect(() => {
    if (!syncReloadArmed) {
      return;
    }

    const progress = Number(syncStatus.progressPercentage ?? 0);
    const total = Number(syncStatus.totalUsersToSync ?? 0);
    const processed = Number(syncStatus.processedUsers ?? 0);
    const completed = progress >= 100 || (total > 0 && processed >= total);

    if (syncStatus.isRunning || !completed) {
      return;
    }

    setSyncReloadArmed(false);
    window.location.reload();
  }, [
    syncReloadArmed,
    syncStatus.isRunning,
    syncStatus.progressPercentage,
    syncStatus.totalUsersToSync,
    syncStatus.processedUsers,
  ]);

  const viewToggleModalErros = () => {
    toggleModalErros(true);
  };

  const showFile = () => {
    Repo.downloadCsvOperator(apiToken, query.get("id"), props?.filterSubscribed)
      .then((response) => {
        if (response.status == 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Template_" + new Date().toLocaleDateString("it-IT") + ".csv",
          );
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      });
  };

  const calcoloCostoIsee = (otherService, isee) => {
    const today = formatDate();

    if (isee == null || isNaN(isee)) return null;

    if (otherService) {
      let bands = props.bands.filter(
        (y) =>
          y.min <= isee &&
          y.max >= isee &&
          parseDate(y.dataVigore) <= parseDate(today),
      );

      if (bands.length === 0) {
        bands = props.bands.filter((y) => y.min <= isee && y.max >= isee);
      }

      const band = bands.sort(
        (a, b) => new Date(b.dataVigore) - new Date(a.dataVigore),
      )[0];

      return band
        ? (band.fixedCost / 2).toLocaleString("it-IT", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : null;
    } else {
      let bands = props.bands.filter(
        (y) =>
          y.min <= isee &&
          y.max >= isee &&
          parseDate(y.dataVigore) <= parseDate(today),
      );

      if (bands.length === 0) {
        bands = props.bands.filter((y) => y.min <= isee && y.max >= isee);
      }

      const band = bands.sort(
        (a, b) => new Date(b.dataVigore) - new Date(a.dataVigore),
      )[0];

      return band?.costoFinale ?? null;
    }
  };

  function parseDate(str) {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  }

  const formatDate = () => {
    const rawMonth = parseInt(props.filterMonth, 10);
    const baseYear = Number(props.session?.anno) || new Date().getFullYear();
    const normalizedMonth = rawMonth > 12 ? rawMonth - 12 : rawMonth;
    const normalizedYear = rawMonth > 12 ? baseYear + 1 : baseYear;

    const date = new Date(
      `${normalizedYear}-${String(normalizedMonth).padStart(2, "0")}-28`,
    );
    return date.toLocaleDateString("it-IT");
  };

  const generatePagoPA = () => {
    const rawMonth = parseInt(props.filterMonth, 10);
    const baseYear = Number(props.session?.anno) || new Date().getFullYear();
    const normalizedMonth = rawMonth > 12 ? rawMonth - 12 : rawMonth;
    const normalizedYear = rawMonth > 12 ? baseYear + 1 : baseYear;
    const paymentReferenceDate = {
      mese: String(normalizedMonth).padStart(2, "0"),
      anno: normalizedYear,
      data: `${String(normalizedMonth).padStart(2, "0")}/${normalizedYear}`,
    };

    setLoading(false);
    Repo.sendMyPay(
      apiToken,
      query.get("id"),
      paymentReferenceDate,
      fiscalcode,
      pagamentoPersonalizzato.importoPagoPA,
      pagamentoPersonalizzato.descrizione,
    )
      .then((response) => {
        if (response.status === 200) {
          setLoading(true);
          toggleModalCSVUpload(!isOpenCSVUpload);
          setAlertShow(true);
          setAlertMessage("Bollettini generati correttamente");
        }
      })
      .catch((error) => {
        setLoading(true);
        console.error(error);
        toggleModalCSVUpload(!isOpenCSVUpload);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setDescription(value);
  };

  const confirmUser = (state, sub) => {
    var obj = {};

    if (state == 2) {
      setWeeklyHourValidation(true);

      obj = {
        id: sub.id,
        state: state,
        weeklyHour: weeklyHour,
      };
      if (weeklyHour == null) {
        hoursValidation = false;
      }
    } else {
      obj = {
        id: sub.id,
        state: state,
        descrizione: description,
      };
    }

    Repo.postConfirmUser(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.status == 200) {
          props.apiGet();
        }
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      })
      .finally(() => {
        toggleModalConfirmUser(false);
        toggleRefuseUserModal(false);
      });
  };

  const returnBodyModalConfirmUser = () => {
    return (
      <>
        <div className="row p-2">
          {props.session.service &&
          props.session.service.name.toLowerCase().includes("taxi") ? (
            <p>
              Per confermare l'utente è necessario inserire il numero di corse
              settimanali:
            </p>
          ) : (
            <p>
              Per confermare l'utente è necessario inserire il numero di ore
              settimanali:
            </p>
          )}
        </div>
        <div className="row mt-3 d-flex justify-content-left">
          <div className="col-lg-6">
            <Input
              id="weeklyHour"
              label={
                props.session.service &&
                props.session.service.name.toLowerCase().includes("taxi")
                  ? "Corse Settimanali"
                  : "Ore Settimanali"
              }
              type="number"
              name="weeklyHour"
              onChange={(e) => setWeeklyHour(e.target.value)}
            />
          </div>
        </div>
      </>
    );
  };

  const returnBodyModalHoursUser = () => {
    return (
      <>
        <div className="row p-2">
          {props.session.service &&
          props.session.service.name.toLowerCase().includes("taxi") ? (
            <p>
              Per confermare l'utente è necessario inserire il numero di corse
              settimanali:
            </p>
          ) : (
            <p>
              Per confermare l'utente è necessario inserire il numero di ore
              settimanali:
            </p>
          )}
        </div>
        <div className="row mt-3 d-flex justify-content-left">
          <div className="col-lg-6">
            <Input
              id="weeklyHour"
              label={
                props.session.service &&
                props.session.service.name.toLowerCase().includes("taxi")
                  ? "Corse Settimanali"
                  : "Ore Settimanali"
              }
              type="number"
              name="weeklyHour"
              onChange={(e) => setWeeklyHour(e.target.value)}
            />
          </div>
        </div>
      </>
    );
  };

  const unsubscribeUser = () => {
    Repo.postUnsubscribeUser(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          toggleModalConfirmUser(false);
          toggleModalUnsubscribe(!isOpenUnsubscribe);
          props.apiGet();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sendRanking = () => {
    let passedValidation = true;
    setValidation(true);

    if (!editScoreData.rankingScore) passedValidation = false;

    if (passedValidation) {
      Repo.postUpdateRanking(apiToken, editScoreData)
        .then((response) => {
          if (response.status == 200) {
            toggleModalEditScore(!editScoreData);
            props.apiGet();
            setValidation(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setValidation(false);
        });
    }
  };

  const sendHours = (id) => {
    Repo.postModifyHours(
      apiToken,
      id,
      props.filterMonth,
      editHoursData.weeklyHour,
    )
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      });
  };

  const bodyRanking = () => {
    return (
      <>
        <div className="row">
          <div className="col">
            <label htmlFor="ranking">Punteggio Graduatoria</label>
            <Input
              id={"ranking" + editScoreData.id}
              name={"ranking" + editScoreData.id}
              value={
                editScoreData.rankingScore
                  ? editScoreData.rankingScore.toString()
                  : ""
              }
              onChange={(e) =>
                setEditScoreData({
                  ...editScoreData,
                  rankingScore: parseInt(e.target.value),
                })
              }
              {...(validation &&
                !editScoreData.rankingScore && {
                  infoText: "Il campo non può essere vuoto!",
                  className: "text-danger",
                })}
            />
          </div>
        </div>
      </>
    );
  };

  const bodyError = (error) => {
    return <p className="p-3 mb-2 text-danger">{error}</p>;
  };

  const bodyHours = () => {
    return (
      <>
        <div className="row">
          Confermi di voler modificare le ore per l'utente ed il mese
          selezionato?
        </div>
        <div className="row mt-4">
          <div className="col-4">
            <Input
              id={"weeklyHour" + editHoursData.id}
              name={"weeklyHour" + editHoursData.id}
              label="Ore intervento"
              type="number"
              value={
                editHoursData.weeklyHour
                  ? editHoursData.weeklyHour.toString()
                  : "0"
              }
              onChange={(e) =>
                setEditHoursData({
                  ...editHoursData,
                  weeklyHour: parseFloat(e.target.value),
                })
              }
            />
          </div>
        </div>
      </>
    );
  };

  const expandedRow = (x) => {
    return (
      <>
        <tr
          className="collapse accordion-collapse"
          id={"collapseExample_" + x.id}
          data-bs-parent={"#collapseExample_" + x.id}
        >
          <td colSpan="12">
            <div className="row justify-content-end">
              <div className="col-lg-0 mx-1"></div>
              <div className="col-lg-0 mx-1">
                <button
                  type="button"
                  className="btn btn-outline-primary p-2 mr-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Modifica ore"
                  onClick={() => {
                    toggleModalEditHours(!editHours);
                    setEditHoursData({
                      id: x.id,
                      weeklyHour: parseFloat(
                        x.subscriptionUsages.find(
                          (u) => u.mese === props.filterMonth,
                        )?.ore ?? 0,
                      ),
                      name: (
                        x.user.firstName +
                        " " +
                        x.user.lastName
                      )?.toUpperCase(),
                    });
                  }}
                >
                  <svg className="icon icon-primary">
                    <use href={`${iconSprite}#it-clock`} />
                  </svg>
                </button>
              </div>
              <div className="col-0 mr-2">
                <Link
                  to={
                    "/lista_utenti/cartella_sociale/dettagli_iscrizione?id=" +
                    x.id
                  }
                >
                  <button
                    type="button"
                    className="btn btn-outline-primary  p-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Dettaglio iscrizione"
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-user`} />
                    </svg>
                  </button>
                </Link>
              </div>
              <div className="col-0 mr-2">
                <Link to={"/lista_utenti/cartella_sociale?id=" + x.user.id}>
                  <button
                    type="button"
                    className="btn btn-outline-primary  p-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Cartella sociale"
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-folder`} />
                    </svg>
                  </button>
                </Link>
              </div>
              {props?.session?.hasPayment && (
                <>
                  <div className="col-0">
                    <Link
                      to={
                        "/lista_interventi/dettaglio_intervento/lista_pagamenti?id=" +
                        x.id
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-outline-primary float-right p-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Pagamenti"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-card`} />
                        </svg>
                      </button>
                    </Link>
                  </div>
                  <div className="col-0 ml-2 mr-2">
                    <button
                      type="button"
                      className="btn btn-outline-primary p-2"
                      title="Invia pagamento"
                      onClick={() => {
                        toggleModalGenerateCSV(!isOpenGenerateCSV);
                        setSetFiscalcode(x.user.fiscalCode);
                        setHaveUsage(
                          x.subscriptionUsages.some(
                            (u) => u.mese === props.filterMonth,
                          ),
                        );
                        setSetTempoCost(
                          x.subscriptionUsages.find(
                            (u) => u.mese === props.filterMonth,
                          )?.cost ?? null,
                        );
                        setAnnouncementId(x.announcementId);
                      }}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-upload`} />
                      </svg>
                    </button>
                  </div>
                </>
              )}
              <div className="col-0 ml-2 mr-2">
                <button
                  className="btn btn-outline-danger btn-xs"
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Eliminazione iscrizione"
                  onClick={() => {
                    toggleModalUnsubscribe(!isOpenUnsubscribe);
                    setId(x.id);
                    setUserId(x.user.id);
                  }}
                >
                  <svg className="icon icon-danger">
                    <use href={`${iconSprite}#it-delete`} />
                  </svg>
                </button>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    props.setFilterSubscribed({
      ...props.filterSubscribed,
      [name]: value,
    });
  };

  return (
    <>
      <div
        className="row p-2 text-white rounded"
        style={{ backgroundColor: "#5597d4" }}
      >
        <div className="col-lg-4 col-6">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h5 className="mb-0 mr-2">
              <b>Utenti Iscritti</b>{" "}
              {filteredItems?.length > 0 && (
                <span
                  className="badge badge-light"
                  data-bs-toggle="tooltip"
                  title="Numero utenti iscritti"
                >
                  {filteredItems.length}
                </span>
              )}
            </h5>
            {props?.session?.externalId && (
              <button
                type="button"
                className="btn btn-outline-white responsive p-2"
                onClick={startPnrrSynchronization}
                disabled={syncStatus.isRunning}
                title="Avvia sincronizzazione utenti PNRR"
              >
                <svg className="icon icon-white">
                  <use href={`${iconSprite}#it-refresh`} />
                </svg>
                <span className="align-middle">
                  {syncStatus.isRunning
                    ? "Sincronizzazione in corso..."
                    : "Sincronizzazione"}
                </span>
              </button>
            )}
          </div>
        </div>

        {!props.isExternalLock ? (
          <>
            {width > 992 ? (
              <>
                <div className="col-lg-4 col-12  text-lg-right text-center"></div>
                <div className="col-lg-2 col-12  text-lg-right text-center">
                  <button
                    type="button"
                    className="btn btn-outline-white  responsive p-2"
                    onClick={() => showFile()}
                  >
                    <svg className="icon icon-white">
                      <use href={`${iconSprite}#it-download`} />
                    </svg>
                    <span className="align-middle">Scarica template</span>
                  </button>
                </div>
                <div className="col-lg-2 col-12 text-lg-right text-center">
                  <button
                    type="button"
                    className="btn btn-outline-white responsive p-2"
                    onClick={() => props.toggleModalImport(!props.isOpenImport)}
                  >
                    <svg className="icon icon-white">
                      <use href={`${iconSprite}#it-upload`} />
                    </svg>
                    <span className="align-middle">Importa dati</span>
                  </button>
                </div>
              </>
            ) : (
              <div className="col-6 text-right mt-1">
                <div className="dropdown dropdownbottom">
                  <button
                    className="btn btn-dropdown dropdown-toggle"
                    id="dropdownMenuDropup"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="text-white mr-2">Opzioni</span>
                    <svg className="icon icon-white">
                      <use href={`${iconSprite}#it-burger`} width="70%" />
                    </svg>
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuDropup"
                  >
                    <div className="link-list-wrapper">
                      <ul className="link-list">
                        <li>
                          <a
                            className="dropdown-item list-item"
                            onClick={() => showFile()}
                          >
                            <svg className="icon icon-primary icon-xs mr-1">
                              <use href={`${iconSprite}#it-download`} />
                            </svg>
                            <span className="align-middle">
                              Scarica template
                            </span>
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item list-item"
                            onClick={() =>
                              props.toggleModalImport(!props.isOpenImport)
                            }
                          >
                            <svg className="icon icon-primary icon-xs mr-1">
                              <use href={`${iconSprite}#it-upload`} />
                            </svg>
                            <span className="align-middle">Importa dati</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="col-lg-4 col-12 "></div>

            <div className="col-lg-2 col-12  text-lg-right text-center">
              <button
                type="button"
                className="btn btn-outline-white  responsive p-2"
                onClick={() => showFile()}
              >
                <svg className="icon icon-white">
                  <use href={`${iconSprite}#it-download`} />
                </svg>
                <span className="align-middle">Scarica template</span>
              </button>
            </div>
            <div className="col-lg-2 col-12 text-lg-right text-center">
              <button
                type="button"
                className="btn btn-outline-white responsive p-2"
                onClick={() => props.toggleModalImport(!props.isOpenImport)}
              >
                <svg className="icon icon-white">
                  <use href={`${iconSprite}#it-upload`} />
                </svg>
                <span className="align-middle">Importa dati</span>
              </button>
            </div>
          </>
        )}

        {syncStatus.isRunning && (
          <div className="col-12 mt-3">
            <div className="progress" style={{ height: "20px" }}>
              <div
                className={
                  "progress-bar " +
                  (syncStatus.isRunning
                    ? "progress-bar-striped progress-bar-animated bg-info"
                    : "bg-success")
                }
                role="progressbar"
                style={{ width: `${syncStatus.progressPercentage}%` }}
                aria-valuenow={syncStatus.progressPercentage}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {syncStatus.progressPercentage}%
              </div>
            </div>
            <small className="text-white d-block mt-1">
              {syncStatus.processedUsers}/{syncStatus.totalUsersToSync || 0}{" "}
              utenti processati.
            </small>
          </div>
        )}

        {!syncStatus.isRunning && lastSyncRef.current && (
          <div className="col-12 mt-2">
            <small className="text-white d-block">
              Ultima sincronizzazione: {formatLastSyncDate(lastSyncRef.current)}
            </small>
          </div>
        )}

        {syncStatus.lastError && (
          <div className="col-12 mt-2">
            <small className="text-warning d-block">
              Ultimo errore: {syncStatus.lastError}
            </small>
          </div>
        )}
      </div>

      {props.sessionSubscriptionTemp &&
      props.sessionSubscriptionTemp.length > 0 ? (
        <>
          <div className="table-responsive rounded mt-1">
            <table
              className="table table-hover"
              style={{ border: "1px solid #d6dce3" }}
            >
              <thead>
                <tr>
                  <th className="text-center pt-5" scope="col">
                    <Input
                      id="firstName"
                      className="mr-1 pt-3"
                      label="Codice Fiscale"
                      type="text"
                      name="fiscalCode"
                      value={props.filterSubscribed.fiscalCode}
                      onChange={handleFilterChange}
                    />
                  </th>
                  <th
                    className="text-center pt-5"
                    scope="col"
                    style={{ minWidth: "210px", maxWidth: "210px" }}
                  >
                    <Input
                      id="nProtocollo"
                      className="mr-1 pt-3"
                      label="Protocollo"
                      type="text"
                      name="nProtocollo"
                      value={props.filterSubscribed.nProtocollo}
                      onChange={handleFilterChange}
                    />
                  </th>
                  {props.isOperator && (
                    <th
                      className="text-center"
                      scope="col"
                      style={{ minWidth: "160px", maxWidth: "160px" }}
                    >
                      Comune
                      <div
                        className="select-wrapper"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <select
                          name="city"
                          value={props.filterSubscribed.city}
                          onChange={handleFilterChange}
                        >
                          <option value="">Tutti</option>
                          {availableCities.map((c) => (
                            <option key={c} value={c}>
                              {c}
                            </option>
                          ))}
                        </select>
                      </div>
                    </th>
                  )}

                  {props.session.hasPayment ? (
                    <>
                      <th
                        className="text-center"
                        scope="col"
                        style={{ minWidth: "150px", maxWidth: "150px" }}
                      >
                        Isee
                      </th>

                      <th className="text-center" scope="col">
                        Costo (%)
                      </th>
                      {props.session.service &&
                      props.session.service.name
                        .toLowerCase()
                        .includes("taxi") ? (
                        <th className="text-center" scope="col">
                          Corse
                        </th>
                      ) : (
                        <th className="text-center" scope="col">
                          Ore
                        </th>
                      )}
                      <th className="text-center" scope="col">
                        Costo
                      </th>
                      <th
                        className="text-center"
                        scope="col"
                        style={{ minWidth: "210px" }}
                      >
                        Bollettini
                        <div
                          className="select-wrapper"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <select
                            value={paymentStatusFilter}
                            onChange={(e) =>
                              setPaymentStatusFilter(e.target.value)
                            }
                          >
                            <option value="">Tutti</option>
                            <option value="1">Pagato</option>
                            <option value="0">Da pagare</option>
                            <option value="2">Annullato</option>
                            <option value="daCreare">Da creare</option>
                          </select>
                        </div>
                      </th>
                    </>
                  ) : (
                    <>
                      <th className="text-center pt-5" scope="col">
                        <Input
                          id="descrizione"
                          className="mr-1 pt-3"
                          label="Dettagli"
                          type="text"
                          name="descrizione"
                          value={props.filterSubscribed.descrizione}
                          onChange={handleFilterChange}
                        />
                      </th>
                      {props?.session?.service?.tipoServizio == 3 ||
                      props?.session?.service?.tipoServizio == 7 ? (
                        <th className="text-center" scope="col">
                          Ore
                        </th>
                      ) : (
                        <></>
                      )}
                      <></>
                    </>
                  )}
                  <th className="text-center" scope="col">
                    Iscrizioni
                    <div
                      className="select-wrapper"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <select
                        id="confermato"
                        name="confirmed"
                        value={props.filterSubscribed.confirmed}
                        onChange={handleFilterChange}
                      >
                        <option value="">Tutti</option>
                        <option value="ADDED">Aggiunto</option>
                        <option value="LOADED">Caricato</option>
                        <option value="VALIDATED">Validato</option>
                        <option value="REFUSED">Rifiutato</option>
                        <option value="SUSPENDED">Sospeso</option>
                      </select>
                      <span
                        className="badge badge-light"
                        data-bs-toggle="tooltip"
                        title="Utenti filtratii"
                      >
                        {totalCount}
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems?.length > 0 &&
                  currentItems.map((x, index) => (
                    <React.Fragment key={index}>
                      {x.user && (
                        <>
                          <tr height="3em">
                            <td>
                              <strong>
                                {x?.user?.fiscalCode?.toUpperCase()}
                              </strong>{" "}
                              <br /> {x?.user?.lastName}{" "}
                              {x?.user?.firstName}{" "}
                            </td>
                            <td>
                              <b>N.{x.nProtocollo && x.nProtocollo} </b>
                              <br /> {x.dataIscrizione && x.dataIscrizione}
                              {x.dataFine && (
                                <>
                                  {" "}
                                  <br /> Scade il <b>{x.dataFine}</b>
                                </>
                              )}
                            </td>
                            {props.isOperator && (
                              <td>{x?.user?.city || "—"}</td>
                            )}
                            {props.session.hasPayment ? (
                              <>
                                {x.user &&
                                x.user.isees &&
                                x.user.isees.length > 0 ? (
                                  <>
                                    <td className="text-right">
                                      {x.user.isees[0] && (
                                        <div>
                                          {parseFloat(
                                            x.user.isees[0].value,
                                          ).toLocaleString("it-IT")}{" "}
                                          &nbsp;€
                                          <br />
                                          <b>{x.user.isees[0].year}</b>
                                        </div>
                                      )}
                                    </td>
                                    <td className="text-right">
                                      {" "}
                                      <b>
                                        {x.otherServices ? (
                                          <div
                                            className={"text-danger"}
                                            title={
                                              "L’utente beneficia di ulteriori forme di sostegno: il costo del servizio è pari al 50% dell’importo totale, indipendentemente dall’ISEE."
                                            }
                                          >
                                            *
                                            {calcoloCostoIsee(
                                              true,
                                              x.user.isees[0].value,
                                            )}{" "}
                                            €
                                          </div>
                                        ) : (
                                          <>
                                            {calcoloCostoIsee(
                                              false,
                                              x.user.isees[0].value,
                                            )}
                                          </>
                                        )}
                                      </b>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td className="text-right"> N/D </td>
                                    <td className="text-right"> - </td>
                                  </>
                                )}
                                <td className="text-right">
                                  {x.subscriptionUsages &&
                                  x.subscriptionUsages.find(
                                    (x) => x.mese == props.filterMonth,
                                  )?.ore
                                    ? x.subscriptionUsages.find(
                                        (x) => x.mese == props.filterMonth,
                                      )?.ore
                                    : "-"}
                                </td>
                                <td className="text-right">
                                  {x.subscriptionUsages &&
                                  x.subscriptionUsages.find(
                                    (x) => x.mese == props.filterMonth,
                                  ) ? (
                                    <>
                                      {parseFloat(
                                        x.subscriptionUsages.find(
                                          (x) => x.mese == props.filterMonth,
                                        )?.cost,
                                      ).toLocaleString("it-IT") + "€"}
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {x?.payments
                                    ?.filter(
                                      (z) =>
                                        z.subscriptionUsageId ===
                                        x.subscriptionUsages.find(
                                          (x) => x.mese == props.filterMonth,
                                        )?.id,
                                    )
                                    ?.map((y, index) => (
                                      <div
                                        key={index}
                                        className="d-flex justify-content-center align-items-center mt-1"
                                      >
                                        <span
                                          className={
                                            "badge rounded-pill text-white " +
                                            (y.stato === 1
                                              ? "bg-success"
                                              : y.stato === 2
                                                ? "bg-danger"
                                                : "bg-primary")
                                          }
                                          style={{
                                            fontSize: "0.9rem",
                                            padding: "0.3em 0.7em",
                                          }}
                                          title={
                                            y.stato === 1
                                              ? "Pagamento effettuato"
                                              : y.stato === 2
                                                ? "Pagamento annullato"
                                                : "Pagamento in attesa"
                                          }
                                        >
                                          {y.importoDovuto}€
                                        </span>
                                        <Badge
                                          badgeStatus={
                                            y.isEmailSent
                                              ? "bg-success"
                                              : "bg-danger"
                                          }
                                          badgeText={
                                            <svg
                                              className="icon icon-white icon-xs"
                                              style={{
                                                fontSize: "1.3em",
                                                width: "1.3em",
                                                height: "1.3em",
                                              }}
                                            >
                                              <use
                                                href={`${iconSprite}#it-mail`}
                                              />
                                            </svg>
                                          }
                                          title={
                                            y.isEmailSent
                                              ? "Invio email avvenuto"
                                              : "Invio email non avvenuto"
                                          }
                                        />

                                        <Badge
                                          badgeStatus={
                                            y.ioId && y.ioId !== "-1"
                                              ? "bg-success"
                                              : "bg-danger"
                                          }
                                          badgeText={
                                            <img
                                              src={IO}
                                              className="icon icon-white icon-xs ml-1 img-io"
                                              style={{
                                                fontSize: "1.3em",
                                                width: "1.3em",
                                                height: "1.3em",
                                              }}
                                              alt={`${
                                                x.ioId
                                                  ? x.ioId
                                                  : "Notifica non inviata"
                                              }`}
                                            />
                                          }
                                          title={
                                            y.ioId && y.ioId !== "-1"
                                              ? "Invio tramite IO avvenuto"
                                              : "Invio tramite IO non avvenuto"
                                          }
                                        />
                                      </div>
                                    ))}
                                </td>
                              </>
                            ) : (
                              <>
                                <td>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: x.descrizioneIstanze,
                                    }}
                                  ></span>
                                </td>
                                {props?.session?.service?.tipoServizio == 3 ||
                                props?.session?.service?.tipoServizio == 7 ? (
                                  <td className="text-right">
                                    {x.subscriptionUsages &&
                                    x.subscriptionUsages.find(
                                      (x) => x.mese == props.filterMonth,
                                    )?.ore
                                      ? x.subscriptionUsages.find(
                                          (x) => x.mese == props.filterMonth,
                                        )?.ore
                                      : "-"}
                                  </td>
                                ) : (
                                  <></>
                                )}
                                <></>
                              </>
                            )}
                            <td>
                              <div className="row">
                                <div className="col-8 pl-5 d-flex text-end">
                                  {renderStatus(x.state)}
                                </div>
                                <div className="col-4">
                                  <button
                                    type="button"
                                    className="btn rounded btn-xs"
                                    data-toggle="collapse"
                                    href={"#collapseExample_" + x.id}
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls={"collapseExample_" + x.id}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Opzioni"
                                  >
                                    <svg className="icon icon-primary">
                                      <use
                                        xlinkHref={`${iconSprite}#it-expand`}
                                      ></use>
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {expandedRow(x)}
                        </>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>

          {props.sessionSubscriptionTemp && (
            <Pagination
              key={filteredItems + changeSort + changeSortRanking}
              items={filteredItems}
              setCurrentItems={setCurrentItems}
              itemsPerPage={itemsPerPage}
            />
          )}

          <div className="row mt-4">
            <div className="col-lg-11">
              <p className="mt-2">
                {itemsPerPage < filteredItems.length ? (
                  <>
                    Mostro <strong>{itemsPerPage}</strong> su{" "}
                    <strong>{filteredItems.length}</strong>
                  </>
                ) : (
                  <>
                    Mostro <strong>{filteredItems.length}</strong> su{" "}
                    <strong>{filteredItems.length}</strong>
                  </>
                )}
              </p>
            </div>
            <div className="col-lg-1 float-right">
              <Select
                aria-label="Servizio"
                defaultMenuIsOpen={false}
                required
                icon={false}
                name="servizio"
                id="servizio"
                options={[
                  { value: 10, label: "10" },
                  { value: 25, label: "25" },
                  { value: 50, label: "50" },
                ]}
                onChange={(e) => setItemsPerPage(e.value)}
                placeholder={itemsPerPage.toString()}
              />
            </div>
          </div>
        </>
      ) : (
        <span className="text mt-3">Non ci sono utenti iscritti.</span>
      )}

      <ModalComponent
        labelledBy="modalConfirm"
        isOpen={isOpenUnsubscribe}
        toggleModal={() => toggleModalUnsubscribe(!isOpenUnsubscribe)}
        header="Eliminazione iscrizione utente"
        body="Confermi di voler eliminare l'iscrizione dell'utente selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => unsubscribeUser()}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={() => toggleModalEditScore(!editScore)}
        isOpen={editScore}
        header={"Modifica punteggio graduatoria di " + editScoreData.name}
        body={bodyRanking()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRanking()}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleModalConfirmUser}
        isOpen={isOpenConfirmUser}
        header="Conferma Utente"
        body={returnBodyModalConfirmUser()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => confirmUser(2, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleRefuseUserModal}
        isOpen={isOpenRefuseUser}
        header="Iscrizione utente"
        body={
          <>
            Confermi di voler rifiutare l'iscrizione dell'utente selezionato?
            <div className="form-group my-4">
              <label htmlFor="descrizione">Descrizione*</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={description || ""}
                onChange={handleChange}
                className="custom-textarea"
                rows={3}
              />
            </div>
          </>
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => confirmUser(3, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleSuspendUserModal}
        isOpen={isOpenSuspendUser}
        header="Sospensione utente"
        body="Confermi di voler sospendere l'iscrizione dell'utente selezionato? Potrai riattivarlo in seguito"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => suspendUser(4, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleReactiveUserModal}
        isOpen={isOpenReactiveUser}
        header="Riattiva utente"
        body="Confermi di voler riattivare l'iscrizione dell'utente selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => suspendUser(2, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleReactiveRefusedUserModal}
        isOpen={isOpenReactiveRefusedUser}
        header="Riattiva utente"
        body="Confermi di voler riattivare l'utente selezionato? Dovrai in seguito accettare l'iscrizione"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => suspendUser(0, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleModalConfirmHours}
        isOpen={isOpenConfirmHours}
        header="Conferma ore utente"
        body={returnBodyModalHoursUser()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => confirmUser(2, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={() => toggleModalEditScore(!editScore)}
        isOpen={editScore}
        header={"Modifica punteggio graduatoria di " + editScoreData.name}
        body={bodyRanking()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRanking()}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalEditHours"
        toggleModal={() => toggleModalEditHours(!editHours)}
        isOpen={editHours}
        header={
          "Modifica ore intervento di " +
          editHoursData.name +
          " mese di " +
          props.getMonthName
        }
        body={bodyHours()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendHours(editHoursData.id)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalEditHours"
        toggleModal={() => toggleModalErros(!isError)}
        isOpen={isError}
        header="Errore"
        body={bodyError(errorMessage)}
        buttonConfirm="Conferma"
        function={() => toggleModalErros(false)}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalGenerateCSV}
        isOpen={isOpenGenerateCSV}
        header={"Invio singolo pagamento"}
        body={
          <>
            {haveUsage ? (
              <>
                {tempoCost > 0 ? (
                  <>
                    Vuoi davvero generare il bollettino pagoPa del mese di{" "}
                    <b>{props.getMonthName}</b> per l'utente <b>{fiscalcode}</b>
                    ?
                    <div className="alert alert-warning alert-pay mt-3 mx-5">
                      L'importo che l'utente dovrà pagare sarà di{" "}
                      <b>{tempoCost} €</b>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="alert alert-warning alert-pay mt-3">
                      <b>Nessun importo</b> previsto per l'utente{" "}
                      <b>{fiscalcode}</b> nel mese di{" "}
                      <b>{props.getMonthName}</b>.
                    </div>
                  </>
                )}
                <div className="row container mb-2 d-flex align-items-center">
                  <div className="col-lg-6">
                    <Input
                      id="importoPagoPA"
                      label="Importo del PagoPA"
                      type="text"
                      className="mt-4"
                      disabled={!personalizzaPagoPA}
                      value={pagamentoPersonalizzato?.importoPagoPA ?? ""}
                      onChange={(e) =>
                        setPagamentoPersonalizzato({
                          ...pagamentoPersonalizzato,
                          [e.target.id]: formatNumber(e.target.value),
                        })
                      }
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="toggles">
                      <label className="label active">
                        <div className="row text-center">
                          <div className="col-4">
                            <input
                              id="pagamentoAnticipato"
                              type="checkbox"
                              checked={personalizzaPagoPA ?? ""}
                              onChange={(e) => (
                                setPersonalizzaPagoPA(!personalizzaPagoPA),
                                setPagamentoPersonalizzato({
                                  ...pagamentoPersonalizzato,
                                  importoPagoPA: "",
                                  descrizione: "",
                                })
                              )}
                            />
                            <span className="lever me-0"></span>
                          </div>
                          <div className="col-8 ps-0 text-start">
                            Pagamento Personalizzato
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <Input
                      id="descrizione"
                      label="Descrizione del PagoPA"
                      type="text"
                      className="mt-2"
                      maxLength={82}
                      disabled={!personalizzaPagoPA}
                      value={pagamentoPersonalizzato.descrizione ?? ""}
                      onChange={(e) =>
                        setPagamentoPersonalizzato({
                          ...pagamentoPersonalizzato,
                          [e.target.id]: e.target.value,
                        })
                      }
                    />
                    <p className="mt-n3">
                      La descrizione sarà inserita nel bollettino (max 82
                      caratteri). Se vuota, verrà generata automaticamente.
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                Non risultano ore di servizio per l'utente <b>{fiscalcode}</b>{" "}
                nel mese di <b>{props.getMonthName}</b>
              </>
            )}
          </>
        }
        buttonConfirm={haveUsage ? "Conferma" : null}
        buttonConfirmDisabled={
          !(tempoCost > 0) && !(pagamentoPersonalizzato.importoPagoPA > 0)
        }
        buttonDeny="Annulla"
        function={() => generatePagoPA()}
      ></ModalComponent>

      {alertShow && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            zIndex: 20000,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
          }}
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: 400 }}
          >
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-body text-center py-4">
                <div className="mb-3">
                  <svg
                    className="icon icon-success"
                    style={{ width: 60, height: 60 }}
                  >
                    <use href={`${iconSprite}#it-check-circle`} />
                  </svg>
                </div>
                <h4 className="text-success mb-3">Operazione completata</h4>
                <p style={{ fontSize: "1.2rem" }}>{alertMessage}</p>
                <button
                  className="btn btn-success btn-lg mt-4 px-5"
                  onClick={() => window.location.reload()}
                  autoFocus
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
};
export default ListUsers;
